<template>
  <div class="sign">
    <el-dialog width="100%" top="0" :destroy-on-close="true" :close-on-click-modal="false" :visible.sync="visible">
      <sign-canvas class="sign-canvas" ref="SignCanvas" :options="options" v-model="value" />
      <div class="btnList">
        <el-button type="danger" size="small" icon="el-icon-delete" @click="canvasClear()">清 空</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="saveAsImg()">确 定</el-button>
        <el-button type="info" size="small" icon="el-icon-download" @click="downloadSignImg()">下载</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'signDialog',
  props: {
    //图片信息Base64
    src: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      value: '',
      options: {
        isFullScreen: false, //是否全屏手写 [Boolean] 可选
        isFullCover: false, //是否全屏模式下覆盖所有的元素 [Boolean] 可选
        isDpr: false, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: 'round', //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: 'round', //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 0, //canvas宽高 [Number] 可选
        canvasHeight: 0, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        // bgColor: '#fff', //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: '#ff787f', //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: '#101010', // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: 'png', //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
    };
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  created() {
    this.options.canvasWidth = this.InnerWH.width - 10;
    this.options.canvasHeight = this.InnerWH.height - 70;
  },
  watch: {
    InnerWH: {
      handler: function (newVal, oldVal) {
        this.options.canvasWidth = newVal.width - 10;
        this.options.canvasHeight = newVal.height - 70;
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear();
    },

    /**
     * 保存图片
     */
    saveAsImg() {
      const img = this.$refs.SignCanvas.saveAsImg();
      this.$emit('change', img, '2');
      this.visible = false;
    },

    /**
     * 下载图片
     */
    downloadSignImg() {
      this.$refs.SignCanvas.downloadSignImg();
    },
  },
};
</script>

<style lang="less" scoped>
.sign {
  /deep/ .el-dialog {
    background: #b4a078;
    margin: 0 0 0 0 !important;
    .el-dialog__header {
      padding: 0px 0px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .el-button {
    /*font-family STXingkai*/
    font-size: 12px;
    font-weight: 400;
  }
  .sign-canvas {
    display: block;
    margin: 0 auto;
    background: #f4f0ea;
    border-radius: 8px;
  }
}

.btnList {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 20px;
}
</style>
